var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.icon ? _c('div', {
    staticClass: "node-area-icon"
  }, [_c('v-icon', {
    staticClass: "ma-4",
    attrs: {
      "size": "small"
    }
  }, [_vm._v(_vm._s(_vm.icon))])], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }